
import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import CafeteriaSection from './components/CafeteriaSection';
import GaleriaCafeteriaSection from './components/GaleriaCafeteriaSection';
import CafeEspecialidadSection from './components/CafeEspecialidadSection';
import CartaCafeteriaSection from './components/CartaCafeteriaSection';
import ModaConscienteSection from './components/ModaConscienteSection';
import RopaSection from './components/RopaSection';
import UbicacionSection from './components/UbicacionSection';
import VisitanosSection from './components/VisitanosSection';
import ContactoSection from './components/ContactoSection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    // Add scroll listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="min-h-screen bg-stone-50">
      <Header scrolled={scrolled} />
      <Hero />
      <CafeteriaSection />
      <GaleriaCafeteriaSection />
      <CafeEspecialidadSection />
      <CartaCafeteriaSection />
      <ModaConscienteSection />
      <RopaSection />
      <UbicacionSection />
      <VisitanosSection />
      <ContactoSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
